<template>
  <b-modal
      :id="modalId"
      modal-class="p-4 big-modal"
      dialog-class="modal-lg"
      content-class="text-center pb-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      lazy
  >
    <div class="gigawhat-modal ml-3 mb-2">
      <div class="modal-heading mt-3">
        <h2 class="modal-title">Documents d’opération</h2>
        <p class="modal-description">
          Liste des documents pour l’opération sélectionnée
        </p>
      </div>


      <div class="giga-files_upload">
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Etablissement
              </h3>
              <p>{{ operation.siteName || "-" }}</p>
            </div>
            <div class="giga-files_header_col_type">
              <h3 class="giga-files_upload_title">
                Fiche
              </h3>
              <p>{{ operation.ficheNumber || "-" }}</p>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Volume précaire
              </h3>
              <p>{{ operation.precarityVolume | formatNumber }} kWh cumac</p>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Volume classique
              </h3>
              <p>{{ operation.classicVolume | formatNumber }} kWh cumac</p>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="mr-5 ml-sm-4">
        <div v-if="documents.length" class="d-flex justify-content-center">
            <div class="table-scroll-wrapper">
              <table class="giga-table" aria-describedby="documents_list">
                <thead>
                <tr style="background-color:#132d48;height:25px" class="text-white">
                  <th class="w-40 text-white">Nom du document</th>
                  <th class="text-white">Date de transmission</th>
                  <th class="text-white">Type</th>
                  <th class="text-white" style="width:10%">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="doc in documents"
                    :key="doc.name"
                    style="background-color:#ebf3fa"
                    class="cursor-pointer"
                >
                  <td><p>
                    {{ doc.nomDuDocument }}
                  </p></td>
                  <td><p>
                    {{ moment(doc.creationDate , "x").format(
                      "DD/MM/YYYY"
                  )}}</p></td>
                  <td>
                    <p>
                      {{
                        doc.types && doc.types.length
                            ? doc.types
                                .map(code => $t(`document_type.${code}`))
                                .join(", ")
                            : ""
                      }}
                    </p>
                  </td>
                  <td class="text-center">
                    <button
                        class="icon-only-btn"
                        @click="downloadFile(doc.id)"
                        :aria-label="`Télécharger ${doc.name}`"
                        title="Télécharger"
                    >
                      <svg
                          width="20"
                          height="17"
                          viewBox="0 0 20 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M18.2386 10.7527V14.0036C18.2386 14.8999 17.3821 15.6267 16.3258 15.6267H2.91284C1.85648 15.6267 0.999969 14.8999 0.999969 14.0036V10.7527"
                            stroke="currentColor"
                            stroke-width="1.69271"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M4.83139 6.68774L9.61642 10.7526L14.4072 6.68774"
                            stroke="currentColor"
                            stroke-width="1.69271"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M9.61639 10.7528V1"
                            stroke="currentColor"
                            stroke-width="1.69271"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>

      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
                id="btn-leave"
                class="giga-blue_outlined_button no-icon"
                @click="hide"
            >
              Quitter
            </button>
          </div>
        </div>
      </div>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {operationService} from "./services/operation.service";
import {documentService} from "../service/document.service";

export default {
  name: "OperationDocuments",
  props: {
    modalId: { type: String, required: true },
    operation: { type: Object, required: true }
  },
  data() {
    return {
      documents: []
    };
  },
  mounted() {
    this.loadDocuments();
  },
  watch: {
    operation: "loadDocuments"
  },
  computed: {
    ...mapGetters("document", ["getDocumentsTypes"])
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    hide() {
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    downloadFile(docId) {
      documentService.downloadCommonDocument(docId);
    },
    async loadDocuments() {
      if (!this.operation || !this.operation.id) {
        this.documents = [];
        return;
      }
      try {
        const operationDocs = await operationService.getOperationDocumentsById(this.operation.id);
        this.documents = operationDocs;
      } catch (err) {
        console.error("Erreur fetch documents :", err);
        this.documents = [];
        this.$notification.error("Impossible de charger les documents");
      }
    }
  }
};
</script>


<style scoped lang="scss">
.giga-files_upload_section {
  padding: 10px 30px;
  border-radius: 6px;
  border: 2px solid #e0e7ee;
  width: 96%;
  background-color: #f4f6fa;
  .giga-files_upload_header {
    display: flex;
    flex-wrap: nowrap;
  }

  .giga-files_header_col_action,
  .giga-files_header_col_name,
  .giga-files_header_col_type,
  .giga-files_header_col_date {
    flex: 1;
    max-width: none;
    padding: 0 0.5rem;
  }

  .giga-files_upload_header > div + div {
    margin-left: 1rem;
  }

}

.giga-upload_files_list {
  .giga-upload_file_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .giga-upload_file_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-upload_file_type {
      flex: 0 0 35%;
      max-width: 45%;
    }

    .giga-upload_file_name {
      flex: 0 0 65%;
      max-width: 45%;
      font-size: 15px;
      font-weight: 600;
      color: #132d48;
      display: flex;
      align-items: center;

      .extention-icon {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #e0e7ee;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;

        img {
          width: 20px;
        }
      }
    }
  }
}
.icon-only-btn {
  background: transparent !important;
  border: none !important;
  padding: 4px;
  color: #01588b;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.icon-only-btn svg {
  fill: none;
  stroke: currentColor;
}

.icon-only-btn:hover,
.icon-only-btn:focus,
.icon-only-btn:active {
  background: transparent !important;
  color: #28a745 !important;
}
.table-scroll-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

.table-scroll-wrapper thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
.giga-files_upload_header p {
  font-size: 15px;
  font-weight: 600;
  color: #132d48;
  margin: 0;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
